// extracted by mini-css-extract-plugin
module.exports = {"selector":"cardSelector_selector__UMFfK"};